import { useSelector, shallowEqual } from 'react-redux'
import { selectors } from 'client/reducers/managementReducer'

export default function useManagement(selector) {
  return useSelector(state => selector(state.management), shallowEqual)
}

export { selectors }
